import {
    TopBetsActions,
    TopBetsSetFilterDataAction,
    TopBetsSetLoadingData,
    TopBetsTopic,
} from './nav.constants';
import { AppDispatch, AppThunk, GetState } from '@om-fe/core/core/types';
import {
    apiSubscribeAction,
    apiUnsubscribeAction,
    attachReducerAction,
    detachReducerAction,
} from '@om-fe/core/utils/action';
import {
    getTopBetSliceName,
    getTopBetsTopic,
} from './nav.utils';
import { 
    NavListStateModel,
    locationNavReducerCreator,
} from './nav.reducer';
import { filterNullParams } from '@om-fe/core/utils/router';
import getSlice from '@om-fe/core/utils/get-slice';

export const topBetsSetLoadingData = (slice: string, isLoadingData: boolean = false): TopBetsSetLoadingData => ({
    type: TopBetsActions.SetLoadingData,
    meta: {
        slice,
    },
    payload: {
        isLoadingData,
    },
});

export const topBetsSetFilterData = (
    slice: string,
    disciplineId: string,
    isCategory?: boolean,
): TopBetsSetFilterDataAction => ({
    type: TopBetsActions.SetFilterData,
    meta: {
        slice,
    },
    payload: {
        disciplineId,
        isCategory,
    },
});

export const getTopBets = (
    instanceId: string,
    disciplineId: string,
    isCategory?: boolean,
) => (dispatch: AppDispatch) => {
    const slice: string = getTopBetSliceName(instanceId);
    const topic: TopBetsTopic = getTopBetsTopic(
        disciplineId,
        isCategory,
    ) as TopBetsTopic;

    dispatch(attachReducerAction(slice, locationNavReducerCreator(instanceId)));
    dispatch(topBetsSetFilterData(
        slice,
        disciplineId,
        isCategory,
    ));
    dispatch(apiSubscribeAction(topic.path, filterNullParams(topic.params), slice));
};

export const removeTopBets = (
    instanceId: string,
): AppThunk => (dispatch: AppDispatch, getState: GetState) => {
    const slice: string = getTopBetSliceName(instanceId);
    const locationState: NavListStateModel | undefined = getSlice<NavListStateModel>(getState(), slice);

    if (!locationState) {
        return;
    }

    const topic: TopBetsTopic = getTopBetsTopic(
        locationState.disciplineId!,
        locationState.isCategory,
    ) as TopBetsTopic;

    dispatch(detachReducerAction(slice));
    dispatch(apiUnsubscribeAction(topic.path, filterNullParams(topic.params), slice));
};
